import { useMemo } from 'react';
import { useSubscription } from 'urql';
import { createSharedRegistry } from '@legacy-shared/widgets/core/registry';
import { graphql } from '../lib/graphql';
import { useOrg } from './use-org';

const CONTACT_CENTER_WIDGETS = ['transferToQueue', 'transferToAgent'];

const EnabledOrganizationWidgetsSubscription = graphql(`
  subscription EnabledOrganizationWidgets($organizationId: Uuid!) {
    organizationWidgets(where: { organizationId: { _eq: $organizationId }, enabled: { _eq: true } }) {
      id
      widgetId
    }
  }
`);

const standardWidgetIds = createSharedRegistry()
  .getByTier('standard')
  .map((w) => w.id);

export function useOrgWidgets() {
  const { organizationId } = useOrg();

  const [{ data }] = useSubscription({
    query: EnabledOrganizationWidgetsSubscription,
    variables: { organizationId: organizationId ?? '' },
    pause: !organizationId,
  });

  return useMemo(() => {
    const enabledIds = (data?.organizationWidgets ?? []).map((w) => w.widgetId);
    const hasContactCenter = enabledIds.includes('contact-center');
    const all = [...new Set([...standardWidgetIds, ...enabledIds])];

    return {
      enabledWidgetIds: hasContactCenter ? all : all.filter((id) => !CONTACT_CENTER_WIDGETS.includes(id)),
      hasContactCenter,
      hasAiAgent: enabledIds.includes('ai-agent'),
      isLoading: !!organizationId && data === undefined,
    };
  }, [data, organizationId]);
}
